import { graphql } from 'react-apollo'
import { getAllNodesQuery } from '../queries'
import AdminNodeContainer from '../components/adminNodeContainer'

export default graphql(getAllNodesQuery)(AdminNodeContainer)



// WEBPACK FOOTER //
// ./src/modules/admin/containers/adminNodeContainer.js